import type { ComponentProps } from "react";
import * as DropdownMenuPrimitive from "@radix-ui/react-dropdown-menu";

import { cn } from "../../lib/utils";
import { useOverlayZIndex } from "../../lib/overlay-z-index";

export const DropdownMenuSubContent = ({
  className,
  style: styleProp,
  ...props
}: ComponentProps<typeof DropdownMenuPrimitive.SubContent>) => {
  // Submenus nest above their parent dropdown via the same nesting-aware system; the parent's
  // OverlayLayerProvider (set up in DropdownMenuContent) supplies the base this offset builds on.
  const { style, className: zClassName } = useOverlayZIndex("dropdown");

  return (
    <DropdownMenuPrimitive.SubContent
      data-slot="dropdown-menu-sub-content"
      style={{ ...style, ...styleProp }}
      className={cn(
        "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 min-w-[8rem] origin-(--radix-dropdown-menu-content-transform-origin) overflow-hidden rounded-md border p-1 shadow-lg",
        zClassName,
        className
      )}
      {...props}
    />
  );
};
